<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.numero"
                        label="Número"
                        v-mask="numeroMask"
                        v-model="model.numero"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :validations="validations.observacao"
                        label="Observação"
                        uppercase
                        v-model="model.observacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </div>
</template>

<script>
// Mixins.
import { object, mask } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                numero: {
                    required: true,
                    min_max_without_mask: [10, 11]
                },
                observacao: {
                    max: 50
                }
            }
        },
        numeroMask() {

            if (this.model.numero === '') {

                return ''
            }

            return this.model.numero.length < 15 ? this.mask.phone : this.mask.cellPhone
        },
    },
    data: () => ({
        model: {
            numero: '',
            observacao: null
        },
    }),
    methods: {
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.data.model.telefones.push(this.clone(this.model))

                    this.$emit('save')
                })
        },
    },
    mixins: [ object, mask ],
    props: {
        data: { type: Object, required: true }
    },
}
</script>